<div id="move-folder-dialog-container">
    <h1 mat-dialog-title>{{ 'dialog.move-folder.label.title' | translate: { folderName: data.node.name } }}</h1>
    <mat-error [@openClose]="moveFolderError ? 'open' : 'closed'" mat-dialog-title>
        {{moveFolderError}}
    </mat-error>
    <div mat-dialog-content>
        <app-move-tree id="move-tree" [node]="data.node" [mediaTree]="data.mediaTree" [files]="[]"
            (selectFolder)="selectFolder($event)">
        </app-move-tree>
    </div>
    <div mat-dialog-actions>
        <button color="warn" mat-button (click)="onAbortClick()"
            cdkFocusInitial>{{ 'general.button.cancel' | translate | uppercase }}</button>
        <span class="default-spacer"></span>
        <button mat-button (click)="onSelectClick()"
            [disabled]="!selectedFolder">{{ 'general.button.move' | translate | uppercase }}</button>
    </div>
</div>